import { useQuery } from "@tanstack/react-query";
import { getBrokerAccounts } from "services";

export const useBrokerAccounts = (strategyId, onSuccess, onError) => {
  return useQuery({
    queryKey: ["brokerAccounts", strategyId],
    queryFn: () => getBrokerAccounts(strategyId),
    enabled: !!strategyId,
    onSuccess,
    onError,
  });
};
